module.exports = __webpack_public_path__ + "static/media/narsharab.87f9aa2c.png";